import axiosInstance from '@/plugins/axios';

// Listagem oficial de ocupações do CBO (grade do mtecbo.gov.br: código/título da ocupação,
// sinônimo, código/título da família) — read-only, servida pelo BFF em /cbo/list (CON-4866).
const ServiceCboOcupacoes = {
  /**
   * @param {*} body filtros (title/family/family_code)
   * @param {{ page?: number, size?: number }} [opts]
   */
  search: (body, { page = 0, size = 50 } = {}) =>
    axiosInstance.post('cbo/list', body ?? {}, { params: { page, size } }),
};

export default ServiceCboOcupacoes;
